import { type ElementRef, useEffect, useRef } from 'react';
import { useInViewRef } from 'rooks';

export const useTrackNodeSeen = ({ onSeen }: { onSeen: () => void }): ElementRef<any> => {
  const seen = useRef(false);
  const [viewRef, isVisible] = useInViewRef();

  useEffect(() => {
    if (isVisible && !seen.current) {
      onSeen();
      seen.current = true;
    }
  }, [isVisible, onSeen]);

  return viewRef;
};
